import { Autocomplete, Box, Divider, TextField, } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import DeleteIcon from '@mui/icons-material/Delete';
import * as FaIcons from 'react-icons/fa'
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ImageDetails from './ImageDetails';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Cookies from "universal-cookie";
import axios from 'axios';
import mainUnitAPI from '../Network/MainUnit';
const cookies = new Cookies();


export default function Images(props) {

  const [selectedImage, setSelectedImage] = useState("");
  const [t] = useTranslation('common')
  const [imageUrls, setImageUrls] = useState([]);
  const [imageUpdatedLocal, setImageUpdatedLocal] = useState(null)
  const [reload, setReload] = useState(false)

  const rolesRedux = useSelector(state => state.rolesData.roles)

  /// images helper functions
  const handleSizeOfFile = async (e) => {
    if (e.size > 2097152) {
      toast.warn("حجم الملفة تجاوز الحد المسموح");
      return false;
    }
    return true;
  };


  const addImageToList = (e) => {
    if (props?.imageList?.length > 9 && !props?.isUpdateImage) {
      // becase we started from index 0..4=5 items
      toast.warn("لا يمكن رفع اكثر من 10 صور");
      return;
    }

    let image = e.target?.querySelector("input");
    if (image) {
      image.click();
      image = null;
    }
  };
  const setSelectedImageToShow = (itm) => {
    setSelectedImage(itm?.url);
  };
  const handleUpdateImage = (e) => {
    // setSelectedImage(null)

    setImageUpdatedLocal(e)
    props?.setIsUpdatedImage(e);

    let data = document.getElementById("imagesForTask");

    if (data) {
      data.click();
    }
  };

  const handleDeleteImage = async (e, directPath) => {
    if (directPath) {

      setImageUrls(imageUrls?.filter(item => item?.id != e?.id))
      props?.setImageList(props?.imageList?.filter(item => item?.id != e?.id));
      props?.deleteImage(e?.id)
    }
    else {
      props?.setImageList(props?.imageList?.filter(item => item?.url != e?.url));
    }

    setReload(!reload)
  };


  const handleImageNewUploaded = async (e) => {
    if (props?.imageList?.length == 4) {
      toast.warn("لايمكن اختيار اكثر من ملفين");
      return false;

    }
    if (e && e?.target && e.target.files[0]) {
      if (await handleSizeOfFile(e.target.files[0])) {
        try {


          let arr = Array.isArray(props?.imageList) ? props?.imageList : []
          arr?.push({
            url: window.URL.createObjectURL(e?.target?.files[0]),
            file: e?.target?.files[0],

          })

          props?.setImageList(arr);
          setReload(!reload)
          // clearImageAfterUpload()

        } catch (err) {
          console.log(err?.message);
        }
      }
    }
  }






  const handleShowImageDetails = (itm, directPath = false) => {

    if (directPath) {
      setSelectedImage(itm?.full_path);
    }
    else {
      setSelectedImage(itm?.url);
    }
  }
  useEffect(() => {


    return () => {

    }
  }, [reload])





  useEffect(() => {
    console.log("load images");

    const fetchAllImageData = async () => {
      console.log("load images 1");
      if (Array.isArray(props?.imageList) && props?.imageList?.filter(item => item?.path)?.length) {
        console.log("load images 2", props?.imageList?.filter(item => item?.path)?.length);
        const promises = props?.imageList?.filter(item => item?.path).map(async (itm) => {
          console.log("load images 3", itm?.path);
          return {
            ...itm,
            full_path: await fetchImageData(process.env.REACT_APP_API_URL_image + "uploads/images/" + itm?.path)
          }

        });


        const resolvedImageUrls = await Promise.all(promises);
        setImageUrls(resolvedImageUrls);
      } else {
        setImageUrls([]);
      }
    };

    fetchAllImageData();
  }, [props?.imageList]); // Re-run if imageList 


  const fetchImageData = async (imagePath) => {
    try {


      let headerObject = {}
      let params = {}
      if (props?.authFromWialon) {

        let accountId = cookies.get("account_name") ? cookies.get("account_name") : null
        params = {
          username: cookies.get("user_name") ? cookies.get("user_name") : null,
          user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
          account_name: accountId ? encodeURIComponent(accountId) : null,
          account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
          authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
          sid: cookies.get("sid") ? cookies.get("sid") : null,
          baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
          id: cookies.get("id") ? cookies.get("id") : null,

        };
      }
      else {
        const jwt = cookies.get("token");
        headerObject = {
          jwt: jwt
        }
      }


      const result = await mainUnitAPI.mainUnitLoadImage({
        url: imagePath,
        params: params,
        headers: {
          ...headerObject
        },
      })


      console.log("result", result);

      return URL.createObjectURL(result.data);
    } catch (error) {
      console.error('Error fetching image data:', error);
      return null;
    }
  };
  return (
    <>
      {props?.readOnly ? null :
        <Box className="my-0 mb-3 me-4 ">
          {/* <Divider  sx={{
          borderColor:'lightgray',
          marginTop:'20px',
          marginBottom:'20px',
          border:'2px'
        }} /> */}
          <FaIcons.FaCommentAlt style={{ color: "grey", fontSize: "18px" }} />{" "}
          <span style={{ fontFamily: "Cairo-Medium", fontSize: "18px" }}>
            ملاحظة: اكبر عدد للملفات المسموح رفعها 4 بالاضافة ان لا يتجاوز حجم
            الملف
          </span>
          <span style={{ fontFamily: "Cairo-Medium", fontSize: "18px" }}>2MB</span>
        </Box>}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          padding: "0 20px",
          flexWrap: "wrap",
        }}
      >
        {props?.imageList && Array.isArray(props.imageList) && props.imageList?.filter(item => item?.url)?.length
          ?
          props.imageList?.filter(item => item?.url).map((itm) => (

            <Box
              sx={{
                width: "200px !important",
                height: "200px !important",
                borderRadius: "5px",
                //  border:'3px dashed green',
                //  backgroundCOlor:'lightgrey',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                borderRadius: "3px",
                margin: "0px 10px",
                boxShadow: '0 0 15px -2px rgba(0,0,0,0.3)',
                margin: '10px 7px',
                // background: "#ebebeb",
                zIndex: 10,
                //  flexGrow:'1',
                //  flexBasis:'1',

                position: "relative",
                flexDirection: "column",
              }}
            >
              <Box sx={{ width: '100%', height: '100%' }}>
                <img
                  src={itm?.url}
                  alt="task photo"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    backgroundPosition: "center center",
                  }}
                  onClick={() => setSelectedImageToShow(itm)}
                />
                <Box
                  sx={{
                    width: "fit-content",
                    height: "fit-content",
                    padding: "3px 11px",
                    backgroundColor: "#414141",
                    borderRadius: "10px",
                    dispaly: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    position: "absolute",
                    top: "5px",
                    right: "10px",
                    zIndex: 32,
                    // pointerEvents:''
                  }}
                >

                  <VisibilityIcon
                    sx={{
                      color: "#fff",
                      fontSize: "20px",
                      margin: "0 3px",
                      cursor: "poinrt",
                      "&:hover": {
                        transform: "scale(1.3)",
                        color: "#fab9b4",
                      },
                    }}
                    onClick={() => handleShowImageDetails(itm)}
                  />
                  {props?.readOnly ? null :
                    <DeleteIcon
                      sx={{
                        color: "#fff",
                        fontSize: "20px",
                        margin: "0 3px",
                        cursor: "poinrt",
                        "&:hover": {
                          transform: "scale(1.3)",
                          color: "#fab9b4",
                        },
                      }}
                      onClick={() => handleDeleteImage(itm)}
                    />}
                  {!props?.editMode && rolesRedux?.update_image?.value && (
                    <CameraswitchIcon
                      sx={{
                        color: "#fff",
                        fontSize: "20px",
                        margin: "0 3px",
                        cursor: "poinrt",
                        "&:hover": {
                          color: "#486b99",
                          transform: "scale(1.3)",
                        },
                      }}
                      onClick={() => handleUpdateImage(itm)}
                    />
                  )}
                </Box>
              </Box>


            </Box>
          )) : null}
        {imageUrls.map((image, index) => (

          <Box
            sx={{
              width: "200px !important",
              height: "200px !important",
              borderRadius: "5px",
              //  border:'3px dashed green',
              //  backgroundCOlor:'lightgrey',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              borderRadius: "3px",
              margin: "0px 10px",
              boxShadow: '0 0 15px -2px rgba(0,0,0,0.3)',
              margin: '10px 7px',
              // background: "#ebebeb",
              zIndex: 10,
              //  flexGrow:'1',
              //  flexBasis:'1',

              position: "relative",
              flexDirection: "column",
            }}
          >
            <Box sx={{ width: '100%', height: '100%' }}>

              <img
                key={index}
                src={image?.full_path}
                alt="task photo"
                style={{
                  width: "200px",
                  height: "200px",
                  objectFit: "cover",
                  backgroundPosition: "center center",
                  margin: "5px",
                }}
                onClick={() => handleShowImageDetails(image, true)} // Assuming order is maintained
              />


              <Box
                sx={{
                  width: "fit-content",
                  height: "fit-content",
                  padding: "3px 11px",
                  backgroundColor: "#414141",
                  borderRadius: "10px",
                  dispaly: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "absolute",
                  top: "5px",
                  right: "10px",
                  zIndex: 32,
                  // pointerEvents:''
                }}
              >

                <VisibilityIcon
                  sx={{
                    color: "#fff",
                    fontSize: "20px",
                    margin: "0 3px",
                    cursor: "poinrt",
                    "&:hover": {
                      transform: "scale(1.3)",
                      color: "#fab9b4",
                    },
                  }}
                  onClick={() => handleShowImageDetails(image, true)}
                />

{props?.readOnly ? null :
                <DeleteIcon
                  sx={{
                    color: "#fff",
                    fontSize: "20px",
                    margin: "0 3px",
                    cursor: "poinrt",
                    "&:hover": {
                      transform: "scale(1.3)",
                      color: "#fab9b4",
                    },
                  }}
                  onClick={() => handleDeleteImage(image, true)}
                />}

              </Box>
            </Box>


          </Box>
        )
        )}

        {(!props?.readOnly && (Array.isArray(props?.imageList) && props?.imageList?.length < 4) || !Array.isArray(props?.imageList) )?
          <Box
            sx={{
              width: "200px !important",
              height: "200px !important",
              borderRadius: "5px",
              border: "3px dashed green",
              //  backgroundCOlor:'lightgrey',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              borderRadius: "3px",
              background: "#ebebeb",
              boxShadow: "14px 14px 14px #d8d8d8,-14px -14px 14px #fefefe",
            }}
            onClick={addImageToList}
          >
            <AddAPhotoIcon
              sx={{ fontSize: "40px", color: "black", pointerEvents: "none" }}
            />
            <input
              type="file"
              className="d-none"
              onChange={handleImageNewUploaded}
              id="imagesForTask"
              accept="image/png, image/gif, image/jpeg,image/jpg"
            />
          </Box> :""}
          {props?.readOnly && !(props?.imageList?.length> 0 || props?.imageList?.lenght>0) ?
          <Box className="my-0 mb-3 me-4 ">
         
          <FaIcons.FaPhotoVideo style={{ color: "grey", fontSize: "18px" }} />{" "}
          <span style={{ fontFamily: "Cairo-Medium", fontSize: "18px" }}>
            لايوجد صور
          </span>
        </Box>:""}

        {selectedImage ? (
          <Box
            sx={{
              position: "fixed",
              width: window.innerWidth,
              height: window.innerHeight,
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backdropFilter: "blur(7px)",
              zIndex: "3539",
            }}
          >
            <img
              src={selectedImage}
              alt="selected photo to show"
              style={{
                width: "600px",
                height: "600px",
                objectFit: "cover",
                backgroundPosition: "center center",
              }}
            />
            <CloseIcon
              sx={{
                position: "fixed",
                top: 10,
                left: 20,
                color: "#47aeed",
                fontSize: "40px",
                zIndex: 234234234,
                cursor: "pinter !important",
                "&:hover": {
                  color: "red",
                },
              }}
              onClick={() => setSelectedImage("")}
            />
          </Box>
        ) : null}

      </Box>
    </>
  );
}
